<template>
    <div>
		<div class="d-flex justify-space-between align-center">
			<v-tabs
				v-model="tabs"
				center-active
				active-class="mid-primary"
				color="white"
            >
                <v-tab :to="{ name: 'add-attendance-type' }">
					<v-icon class="me-1"> mdi-calendar-edit </v-icon>
					{{ $T('Settings.tabs.attendanceType') }}
				</v-tab>

                <v-tab :to="{ name: 'add-job-place' }">
                    <v-icon class="me-1"> mdi-calendar-edit </v-icon>
                    {{ $T('Settings.tabs.jobPlace') }}
                </v-tab>
            </v-tabs>

        </div>
        
		<v-divider></v-divider>

        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabs: 0
        }
    }
}
</script>
